module.exports = __webpack_public_path__ + "img/pufeite2.1399d680.png";